// Writes an element's content width (padding excluded, whole px) to a scope expression, and
// again whenever it changes: <div chart-width="width">. The home charts lay themselves out
// from it. Until the first measurement the width is undefined, and the charts draw no strip,
// bar or plot. An inactive md-tab keeps its width (angular-material only moves it off screen),
// so switching tabs redraws nothing. A ResizeObserver only calls back on a change, so nothing
// runs while the page sits idle, as long as what the charts draw can't change the width they're
// given: the flow plot grows taller as it grows wider, so the Overview's scroller keeps its
// scrollbar's room (md-content.member-overview in main.css) rather than toggle it every frame.
export default function chartWidth($parse) {
  return {
    restrict: 'A',
    link(scope, el, attrs) {
      if (typeof ResizeObserver !== 'function') {
        return;
      }
      const set = $parse(attrs.chartWidth).assign;
      let last = -1;
      const ro = new ResizeObserver(entries => {
        const w = Math.floor(entries[0].contentRect.width);   // content box: padding excluded
        if (w !== last) {
          last = w;
          scope.$applyAsync(() => set(scope, w));
        }
      });
      ro.observe(el[0]);
      scope.$on('$destroy', () => ro.disconnect());
    }
  };
}
